import { render } from "./CookiesIndicator.vue?vue&type=template&id=765757fe&scoped=true"
import script from "./CookiesIndicator.vue?vue&type=script&lang=js"
export * from "./CookiesIndicator.vue?vue&type=script&lang=js"

import "./CookiesIndicator.vue?vue&type=style&index=0&id=765757fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-765757fe"]])

export default __exports__